module.exports = __webpack_public_path__ + "static/media/bytt-no-10.a1ec4518.mp3";